import { IPaginatedResponse, IResponse } from '../../../model';
import { Estados } from '../../../operaciones';
import ServiceBase from '../../../servicebase';
import { IOperacion } from '../model';
import { IOperacionAdjunto } from '../model/IOperacion';

export default class OperacionService extends ServiceBase {
  get = (data:{ id?: number }) : Promise<IResponse<IOperacion>> => 
    this.GetFetch<IResponse<IOperacion>>('entity/operacion', data);

  find = (data:{ 
    pageIndex?: number, pageSize?: number, sort?: string, 
    estado?: number, creafechaDesde?: string, creafechaHasta?: string, 
    codigo?: string, idcotizador?: number, idcliente?: number, idproveedor?: number, idproducto?: number,
    fechadesdeDesde?: string, fechadesdeHasta?: string, fechahastaDesde?: string, fechahastaHasta?: string, 
    voucher?: string, email?: string, whatsapp?: string, codigodescuento?: string, idorigen?: number, iddestino?: number,
    pasajero_nombre?: string, pasajero_apellido?: string, pasajero_documento?: string,
  }) : Promise<IPaginatedResponse<any>> => 
    this.GetFetch<IPaginatedResponse<any>>('entity/operacion/find', data);

  upsert = (data:any) : Promise<IResponse<IOperacion>> => 
    this.PostFetch<IResponse<IOperacion>>('entity/operacion', data);

  updateComentarios = (data:{ id:number, comentarios?: string }) : Promise<IResponse<any>> => 
    this.PutFetch<IResponse<any>>('entity/operacion/comentarios', data);

  updatePago = (data:any) : Promise<IResponse<any>> => 
    this.PutFetch<IResponse<any>>('entity/operacion/pago', data);

  estado = (data: { id?: number, estado?: Estados, idvendedor?: number }) : Promise<IResponse<any>> => 
    this.PutFetch<IResponse<any>>('entity/operacion/estado', data);

  reSendEmailVoucher = (data: { idoperacion?: number }) : Promise<IResponse<any>> => 
    this.GetFetch<IResponse<any>>('entity/operacion/voucher/resendemailvoucher', data);

  comprobantesPago = (data: { id?: number }) : Promise<IResponse<any>> => 
    this.GetFetch<IResponse<any>>('entity/operacion/pago/comprobantes', data);
    
  upsertCbtePago = (data: any) : Promise<IResponse<IOperacionAdjunto>> => 
    this.PostFetch<IResponse<IOperacionAdjunto>>('entity/operacion/pago/comprobante', data);
    
  deleteCbtePago = (data: { id?: number }) : Promise<IResponse<any>> => 
    this.DeleteFetch<IResponse<any>>('entity/operacion/pago/comprobante', data);
}
